export const emptyVerification = () => ({ requestToken: '', otp: '', proof: '', busy: false, error: '' });
export const initialSignupVerification = () => ({ email: emptyVerification(), phone: emptyVerification() });
export const signupVerificationReducer = (state, action) => {
  const { contact, type } = action;
  if (type === 'reset' || (type === 'edit' && contact === 'email')) return initialSignupVerification();
  if (type === 'edit') return { ...state, phone: emptyVerification() };
  const next = { ...state, [contact]: { ...state[contact], ...action.value } };
  if ((type === 'send' || type === 'verified') && contact === 'email') next.phone = emptyVerification();
  if (type === 'send') next[contact] = { ...emptyVerification(), busy: true };
  return next;
};
export const isProofError = (error) => /proof.*(expired|invalid|required)|(expired|invalid|required).*proof|verification.*expired|VERIFY_CONTACTS_AGAIN/i.test(String(error?.response?.data?.code || '') + ' ' + String(error?.message || error));
